import React from "react";
import { useTranslation } from "react-i18next";

function QuestionSelection({ questions, selectedIndex, onSelect, onContinue, loading, screenshotUrl, metadata, autoAdvance = true }) {
  const { t } = useTranslation('fastresearch');
  return (
    <>
      <h1 style={{
        fontSize: "clamp(2rem, 8vw, 2.75rem)",
        marginBottom: "1rem",
        fontWeight: "900",
        color: "#fff",
        letterSpacing: "-0.04em",
        lineHeight: "1",
        textAlign: "center"
      }}>
        {t('questionSelection.title')}
      </h1>

      <p style={{
        fontSize: "clamp(0.9375rem, 3vw, 1rem)",
        color: "#888",
        marginBottom: "2rem",
        lineHeight: "1.5",
        textAlign: "center"
      }}>
        {t('questionSelection.subtitle')}
      </p>

      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.75rem",
        marginBottom: "1.5rem"
      }}>
        {questions?.map((questionObj, index) => {
          const goalTitle = questionObj.goalTitle || questionObj;
          const goalDescription = questionObj.goalDescription || '';
          const isObjectFormat = typeof questionObj === 'object' && questionObj.goalTitle;

          return (
            <div
              key={index}
              onClick={() => {
                if (loading) return;
                if (selectedIndex !== index) {
                  onSelect(index);
                }
                if (autoAdvance) {
                  setTimeout(() => onContinue(index), 300);
                }
              }}
              style={{
                position: "relative",
                padding: "1.25rem 1.5rem",
                borderRadius: "10px",
                backgroundColor: selectedIndex === index ? "rgba(99, 102, 241, 0.2)" : "rgba(255, 255, 255, 0.05)",
                border: selectedIndex === index ? "1px solid rgba(99, 102, 241, 0.5)" : "1px solid rgba(255, 255, 255, 0.1)",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.3s ease",
                textAlign: "left",
                opacity: loading ? 0.6 : 1,
                display: "flex",
                alignItems: "flex-start",
                gap: "0.75rem"
              }}
              onMouseEnter={(e) => {
                if (selectedIndex !== index && !loading) {
                  e.currentTarget.style.backgroundColor = "rgba(99, 102, 241, 0.1)";
                  e.currentTarget.style.borderColor = "rgba(99, 102, 241, 0.3)";
                }
              }}
              onMouseLeave={(e) => {
                if (selectedIndex !== index && !loading) {
                  e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
                  e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.1)";
                }
              }}
            >
              {index === 0 && (
                <div style={{
                  position: "absolute",
                  top: "-0.55rem",
                  right: "1rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.25rem",
                  padding: "0.2rem 0.6rem",
                  borderRadius: "999px",
                  backgroundColor: "#1a1830",
                  border: "1px solid rgba(167, 139, 250, 0.55)",
                  color: "#c4b5fd",
                  fontSize: "0.6875rem",
                  fontWeight: 700,
                  letterSpacing: "0.04em",
                  textTransform: "uppercase",
                  boxShadow: "0 4px 12px rgba(99, 102, 241, 0.25)"
                }}>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                  </svg>
                  {t('questionSelection.recommended')}
                </div>
              )}
              <div style={{ flex: 1 }}>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.75rem",
                  marginBottom: isObjectFormat && goalDescription ? "0.5rem" : "0"
                }}>
                  {/* Purple icon aligned with heading */}
                  <div style={{
                    color: "#a78bfa",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center"
                  }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                    </svg>
                  </div>
                  <div style={{
                    fontSize: "clamp(0.9375rem, 3.5vw, 1rem)",
                    lineHeight: "1.4",
                    color: "#fff",
                    fontWeight: "700",
                    flex: 1
                  }}>
                    {goalTitle}
                  </div>
                </div>
                {isObjectFormat && goalDescription && (
                  <div style={{
                    fontSize: "clamp(0.8125rem, 3vw, 0.875rem)",
                    lineHeight: "1.5",
                    color: "#888",
                    paddingLeft: "calc(18px + 0.75rem)"
                  }}>
                    {goalDescription}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {loading && (
        <div style={{
          textAlign: "center",
          padding: "2rem",
          fontSize: "clamp(0.875rem, 3vw, 1rem)",
          color: "#999",
          fontWeight: "600"
        }}>
          {t('questionSelection.generatingPersonas')}
        </div>
      )}

    </>
  );
}

export default QuestionSelection;
